/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Contactcodes_ModifyInputs */

const en_enum_permission_name_contactcodes_modify = /** @type {(inputs: Enum_Permission_Name_Contactcodes_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Contactcodes Modify`)
};

const de_enum_permission_name_contactcodes_modify = /** @type {(inputs: Enum_Permission_Name_Contactcodes_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Contactcodes Modify`)
};

/**
* | output |
* | --- |
* | "Name Contactcodes Modify" |
*
* @param {Enum_Permission_Name_Contactcodes_ModifyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_contactcodes_modify = /** @type {((inputs?: Enum_Permission_Name_Contactcodes_ModifyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Contactcodes_ModifyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_contactcodes_modify(inputs)
	return de_enum_permission_name_contactcodes_modify(inputs)
});